import * as React from "react";

const SvgAssignmentTurnedIn = ({ color, size }) => (
  <svg
    viewBox="0 0 32 32"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.3}
      d="M6.666 25.334h18.667V6.667H6.666v18.667zm3.213-9.88 3.454 3.44 8.786-8.787L24 12 13.333 22.667l-5.334-5.333 1.88-1.88z"
      fill={color}
    />
    <path
      d="m24 12-1.88-1.894-8.787 8.787-3.453-3.44L8 17.333l5.333 5.333L24 12zm1.333-8H19.76C19.2 2.453 17.733 1.333 16 1.333c-1.733 0-3.2 1.12-3.76 2.667H6.667c-.187 0-.36.013-.534.053-.52.107-.986.373-1.346.733-.24.24-.44.534-.574.854C4.08 5.96 4 6.293 4 6.666v18.667c0 .36.08.72.213 1.04.134.32.334.6.574.853.36.36.826.627 1.346.734.174.026.347.04.534.04h18.666C26.8 28 28 26.8 28 25.333V6.666C28 5.2 26.8 4 25.333 4zM16 3.666c.547 0 1 .454 1 1 0 .547-.453 1-1 1-.547 0-1-.453-1-1 0-.546.453-1 1-1zm9.333 21.667H6.667V6.666h18.666v18.667z"
      fill={color}
    />
  </svg>
);

export default SvgAssignmentTurnedIn;
